"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BestFitRequirement = void 0;
const scholarship_requirement_type_1 = require("../types/scholarship-requirement-type");
const student_data_requirement_1 = require("./student-data-requirement");
const studentdomain_1 = require("@studyportals/studentdomain");
class BestFitRequirement extends student_data_requirement_1.StudentDataRequirement {
    constructor() {
        super(...arguments);
        this.type = scholarship_requirement_type_1.ScholarshipRequirementType.BEST_FIT;
    }
    getRequiredStudentFields() {
        return [
            studentdomain_1.StudentField.STUDY_LEVEL,
            studentdomain_1.StudentField.STUDY_COUNTRY_ID,
            studentdomain_1.StudentField.DISCIPLINES,
            studentdomain_1.StudentField.GPA,
            studentdomain_1.StudentField.WORK_EXPERIENCE,
            studentdomain_1.StudentField.PROFICIENCY_TYPE,
            studentdomain_1.StudentField.TUITION_BUDGET,
            studentdomain_1.StudentField.LIVING_BUDGET,
        ];
    }
}
exports.BestFitRequirement = BestFitRequirement;
